module.exports = __webpack_public_path__ + "img/warnCenter.c1266c4f.svg";